/*
 * PRD-1705 (PRD R2): with `role-capabilities` on, Permissions Management also lists
 * every surface capability, grouped as the PRD names them. Both Assessments rows are
 * Navy-only and show while `navy-assessment-permissions` is on; their group tells
 * them apart. Actions are resapi's (PRD-1704). Manage Users and the SSO grant move
 * into Manage Organization, the SSO one under its real name (R7).
 */
export const CAPABILITY_GROUPS = [
  {
    label: 'Navigation',
    capabilities: [
      { id: 'access_insights', label: 'Access Insights', action: 'access_insights' },
      { id: 'access_library', label: 'Access Library', action: 'access_library' },
      { id: 'access_activities', label: 'Access Activities', action: 'access_activities' },
    ],
  },
  {
    label: 'Data Sources',
    capabilities: [
      { id: 'view_datasets', label: 'View Datasets', action: 'view_datasets' },
      { id: 'view_connections', label: 'View Connections', action: 'view_connections' },
      { id: 'access_assessments', label: 'Assessments', action: 'access_assessments', navy: true },
    ],
  },
  {
    label: 'Header and Account',
    capabilities: [
      { id: 'access_notifications', label: 'Access Notifications', action: 'access_notifications' },
      { id: 'update_own_profile', label: 'Update Own Profile', action: 'manage_user_context_own' },
    ],
  },
  {
    label: 'Manage Organization',
    capabilities: [
      { id: 'edit_organization', label: 'Edit Organization Profile', action: 'edit_organization' },
      { id: 'manage_users', label: 'Manage Users', action: 'manage_users' },
      { id: 'manage_sso', label: 'Manage SSO', action: 'configure_sso' },
      { id: 'manage_permissions', label: 'Manage Permissions', action: 'manage_permissions' },
      { id: 'manage_assessment_setup', label: 'Assessments', action: 'manage_assessment_setup', navy: true },
    ],
  },
];

// Today's toggles whose action a group now carries.
const GROUPED_ACTIONS = new Set(CAPABILITY_GROUPS.flatMap((g) => g.capabilities.map((c) => c.action)));

/**
 * The rows Permissions Management shows. With capabilities off, today's list as it
 * is; on, the rest of today's list ungrouped, then the groups.
 */
export function permissionSections(baseCapabilities, { capabilitiesOn, navyOn }) {
  if (!capabilitiesOn) return [{ label: null, capabilities: baseCapabilities }];
  return [
    { label: null, capabilities: baseCapabilities.filter((cap) => !GROUPED_ACTIONS.has(cap.action)) },
    ...CAPABILITY_GROUPS.map((g) => ({ ...g, capabilities: g.capabilities.filter((cap) => navyOn || !cap.navy) })),
  ];
}

/** Every action the page can show, once each, for the role matrix. */
export function matrixActions(baseCapabilities) {
  return [...new Set([...baseCapabilities, ...CAPABILITY_GROUPS.flatMap((g) => g.capabilities)].map((c) => c.action))];
}
